/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_account_register_form_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Prosím zadejte následující informace pro vytvoření účtu.`
};

const da_account_register_form_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Indtast venligst følgende oplysninger for at oprette din konto.`
};

const de_account_register_form_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Bitte geben Sie die folgenden Informationen ein, um Ihr Konto zu erstellen.`
};

const en_account_register_form_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Please enter the following information to create your account.`
};

const es_account_register_form_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Por favor, introduce la siguiente información para crear tu cuenta.`
};

const fr_account_register_form_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Veuillez entrer les informations suivantes pour créer votre compte.`
};

const hu_account_register_form_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Kérjük, add meg az alábbi adatokat a fiók létrehozásához.`
};

const it_account_register_form_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Inserisci le seguenti informazioni per creare il tuo account.`
};

const nl_account_register_form_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Vul de volgende gegevens in om een account aan te maken.`
};

const pl_account_register_form_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Wprowadź poniższe dane, aby utworzyć konto.`
};

const pt_account_register_form_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Por favor, insira as informações a seguir para criar sua conta.`
};

const sv_account_register_form_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Fyll i följande information för att skapa ditt konto.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const account_register_form_subtitle = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.account_register_form_subtitle(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("account_register_form_subtitle", locale)
	if (locale === "cs") return cs_account_register_form_subtitle(inputs)
	if (locale === "da") return da_account_register_form_subtitle(inputs)
	if (locale === "de") return de_account_register_form_subtitle(inputs)
	if (locale === "en") return en_account_register_form_subtitle(inputs)
	if (locale === "es") return es_account_register_form_subtitle(inputs)
	if (locale === "fr") return fr_account_register_form_subtitle(inputs)
	if (locale === "hu") return hu_account_register_form_subtitle(inputs)
	if (locale === "it") return it_account_register_form_subtitle(inputs)
	if (locale === "nl") return nl_account_register_form_subtitle(inputs)
	if (locale === "pl") return pl_account_register_form_subtitle(inputs)
	if (locale === "pt") return pt_account_register_form_subtitle(inputs)
	return sv_account_register_form_subtitle(inputs)
};
export { account_register_form_subtitle as "account.register_form_subtitle" }